(function () {
  'use strict';

  if (window.__rnrNativeCardSwatchesLoaded) return;
  window.__rnrNativeCardSwatchesLoaded = true;

  var VISUAL_OPTION_NAMES = ['finish', 'color', 'colour', 'fabric', 'upholstery'];
  var MAX_VISIBLE_SWATCHES = 6;
  var CACHE_PREFIX = 'rnr-native-card-swatches-v1:';
  var memoryCache = new Map();
  var pendingRequests = new Map();
  var observer = null;
  var cardObserver = null;

  function normalizeOptionName(name) {
    return String(name || '').trim().toLowerCase();
  }

  function isVisualOption(name) {
    var normalized = normalizeOptionName(name);
    return VISUAL_OPTION_NAMES.some(function (candidate) {
      return normalized === candidate || normalized.indexOf(candidate) !== -1;
    });
  }

  function getShopRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function getProductHandle(card) {
    var link = card.querySelector('.card__heading a[href*="/products/"]') || card.querySelector('a[href*="/products/"]');
    if (!link) return null;

    try {
      var url = new URL(link.getAttribute('href'), window.location.origin);
      var match = url.pathname.match(/\/products\/([^/?#]+)/i);
      return match ? decodeURIComponent(match[1]) : null;
    } catch (error) {
      return null;
    }
  }

  function getProductUrl(card, product, handle) {
    var link = card.querySelector('.card__heading a[href*="/products/"]') || card.querySelector('a[href*="/products/"]');
    if (link && link.getAttribute('href')) {
      try {
        var url = new URL(link.getAttribute('href'), window.location.origin);
        return url.pathname + url.search + url.hash;
      } catch (error) {
        // Fall through to the product URL below.
      }
    }
    if (product && product.url) return product.url;
    return getShopRoot() + 'products/' + encodeURIComponent(handle);
  }

  function getVariantValue(variant, optionPosition) {
    var index = optionPosition - 1;
    if (variant && Array.isArray(variant.options) && typeof variant.options[index] !== 'undefined') {
      return variant.options[index];
    }
    return variant ? variant['option' + optionPosition] : null;
  }

  function getVariantImage(variant, product) {
    var image = variant && variant.featured_image;
    if (typeof image === 'string') return image;
    if (image && image.src) return image.src;
    if (image && image.url) return image.url;

    var media = variant && variant.featured_media;
    if (media && media.preview_image && media.preview_image.src) return media.preview_image.src;
    if (media && media.preview_image && media.preview_image.url) return media.preview_image.url;

    if (product && Array.isArray(product.images) && variant && variant.image_id) {
      for (var i = 0; i < product.images.length; i += 1) {
        var productImage = product.images[i];
        if (productImage && typeof productImage === 'object' && String(productImage.id) === String(variant.image_id)) {
          return productImage.src || productImage.url || null;
        }
      }
    }

    if (product && typeof product.featured_image === 'string') return product.featured_image;
    if (product && product.featured_image && product.featured_image.src) return product.featured_image.src;
    return null;
  }

  function resizeShopifyImage(url, width) {
    if (!url) return null;
    try {
      var parsed = new URL(url, window.location.origin);
      parsed.searchParams.set('width', width);
      return parsed.toString();
    } catch (error) {
      return url;
    }
  }

  function compactProductData(product, handle) {
    if (!product || !Array.isArray(product.variants) || !Array.isArray(product.options)) return null;

    var visualOption = null;
    for (var i = 0; i < product.options.length; i += 1) {
      var option = product.options[i];
      var optionName = typeof option === 'string' ? option : option && option.name;
      var optionPosition = typeof option === 'object' && option.position ? option.position : i + 1;
      if (isVisualOption(optionName)) {
        visualOption = { name: optionName, position: optionPosition };
        break;
      }
    }

    if (!visualOption) return null;

    var values = new Map();
    var selectedVariant = null;

    product.variants.forEach(function (variant) {
      var value = getVariantValue(variant, visualOption.position);
      if (!value) return;

      if (!selectedVariant && variant.available) selectedVariant = variant;

      var key = String(value);
      var current = values.get(key);
      var variantImage = getVariantImage(variant, product);

      if (!current) {
        current = {
          value: key,
          variantId: variant.id,
          available: Boolean(variant.available),
          image: variantImage
        };
        values.set(key, current);
      } else if (!current.available && variant.available) {
        current.variantId = variant.id;
        current.available = true;
        current.image = variantImage || current.image;
      } else if (!current.image && variantImage) {
        current.image = variantImage;
      }
    });

    var swatches = Array.from(values.values());
    if (swatches.length < 2) return null;

    if (!selectedVariant) selectedVariant = product.variants[0] || null;

    return {
      handle: handle,
      optionName: visualOption.name,
      selectedValue: selectedVariant ? String(getVariantValue(selectedVariant, visualOption.position) || '') : '',
      url: product.url || getShopRoot() + 'products/' + encodeURIComponent(handle),
      swatches: swatches
    };
  }

  function readSessionCache(handle) {
    try {
      var value = window.sessionStorage.getItem(CACHE_PREFIX + handle);
      return value === null ? undefined : JSON.parse(value);
    } catch (error) {
      return undefined;
    }
  }

  function writeSessionCache(handle, value) {
    try {
      window.sessionStorage.setItem(CACHE_PREFIX + handle, JSON.stringify(value));
    } catch (error) {
      // Storage can be unavailable in private browsing or restricted contexts.
    }
  }

  function loadProductSwatches(handle) {
    if (memoryCache.has(handle)) return Promise.resolve(memoryCache.get(handle));
    if (pendingRequests.has(handle)) return pendingRequests.get(handle);

    var stored = readSessionCache(handle);
    if (typeof stored !== 'undefined') {
      memoryCache.set(handle, stored);
      return Promise.resolve(stored);
    }

    var request = fetch(getShopRoot() + 'products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Product data request failed');
        return response.json();
      })
      .then(function (product) {
        var compact = compactProductData(product, handle);
        memoryCache.set(handle, compact);
        writeSessionCache(handle, compact);
        return compact;
      })
      .catch(function () {
        memoryCache.set(handle, null);
        return null;
      })
      .finally(function () {
        pendingRequests.delete(handle);
      });

    pendingRequests.set(handle, request);
    return request;
  }

  function buildVariantUrl(baseUrl, variantId) {
    try {
      var url = new URL(baseUrl, window.location.origin);
      url.searchParams.set('variant', variantId);
      return url.pathname + url.search + url.hash;
    } catch (error) {
      return baseUrl + (baseUrl.indexOf('?') === -1 ? '?' : '&') + 'variant=' + encodeURIComponent(variantId);
    }
  }

  function getPrimaryImage(card) {
    return card.querySelector('.card__media .media > img:first-child');
  }

  function cacheOriginalImage(image) {
    if (!image || image.dataset.rnrOriginalCached === 'true') return;
    image.dataset.rnrOriginalCached = 'true';
    image.dataset.rnrOriginalSrc = image.getAttribute('src') || '';
    image.dataset.rnrOriginalSrcset = image.getAttribute('srcset') || '';
    image.dataset.rnrOriginalSizes = image.getAttribute('sizes') || '';
  }

  function activateSwatch(card, item) {
    if (!item.image) return;
    var image = getPrimaryImage(card);
    if (!image) return;

    cacheOriginalImage(image);
    card.classList.add('is-rnr-swatch-hover');
    image.removeAttribute('srcset');
    image.setAttribute('src', resizeShopifyImage(item.image, 720));
  }

  function restoreCardImage(card) {
    var image = getPrimaryImage(card);
    if (!image || image.dataset.rnrOriginalCached !== 'true') {
      card.classList.remove('is-rnr-swatch-hover');
      return;
    }

    image.setAttribute('src', image.dataset.rnrOriginalSrc || '');
    if (image.dataset.rnrOriginalSrcset) {
      image.setAttribute('srcset', image.dataset.rnrOriginalSrcset);
    } else {
      image.removeAttribute('srcset');
    }

    if (image.dataset.rnrOriginalSizes) {
      image.setAttribute('sizes', image.dataset.rnrOriginalSizes);
    } else {
      image.removeAttribute('sizes');
    }

    card.classList.remove('is-rnr-swatch-hover');
  }

  function renderSwatches(card, data) {
    if (!data || !data.swatches || data.swatches.length < 2) return;

    var oldRow = card.querySelector('.lr-card-swatches');
    if (oldRow) oldRow.remove();

    var row = document.createElement('div');
    row.className = 'lr-card-swatches';
    row.setAttribute('role', 'list');
    row.setAttribute('aria-label', data.optionName);

    var productUrl = getProductUrl(card, data, data.handle);
    var visible = data.swatches.slice(0, MAX_VISIBLE_SWATCHES);

    visible.forEach(function (item) {
      var swatch = document.createElement('a');
      swatch.className = 'lr-card-swatch';
      if (item.value === data.selectedValue) swatch.classList.add('is-selected');
      if (!item.available) swatch.classList.add('is-unavailable');
      swatch.href = buildVariantUrl(productUrl, item.variantId);
      swatch.title = data.optionName + ': ' + item.value;
      swatch.setAttribute('aria-label', data.optionName + ': ' + item.value);
      swatch.setAttribute('role', 'listitem');

      if (item.image) {
        var img = document.createElement('img');
        img.src = resizeShopifyImage(item.image, 80);
        img.alt = '';
        img.width = 36;
        img.height = 36;
        img.loading = 'lazy';
        img.decoding = 'async';
        swatch.appendChild(img);

        swatch.addEventListener('mouseenter', function () {
          activateSwatch(card, item);
        });
        swatch.addEventListener('focus', function () {
          activateSwatch(card, item);
        });
      } else {
        var fallback = document.createElement('span');
        fallback.className = 'lr-card-swatch__fallback';
        fallback.textContent = item.value.slice(0, 2).toUpperCase();
        swatch.appendChild(fallback);
      }

      swatch.addEventListener('mouseleave', function () {
        restoreCardImage(card);
      });
      swatch.addEventListener('blur', function () {
        restoreCardImage(card);
      });

      row.appendChild(swatch);
    });

    if (data.swatches.length > MAX_VISIBLE_SWATCHES) {
      var more = document.createElement('a');
      more.className = 'lr-card-swatches__more';
      more.href = productUrl;
      more.textContent = '+' + (data.swatches.length - MAX_VISIBLE_SWATCHES);
      more.setAttribute('aria-label', '+' + (data.swatches.length - MAX_VISIBLE_SWATCHES));
      more.setAttribute('role', 'listitem');
      row.appendChild(more);
    }

    var info = card.querySelector('.card-information');
    if (!info) return;

    var price = info.querySelector('.price');
    if (price) {
      price.insertAdjacentElement('afterend', row);
    } else {
      info.appendChild(row);
    }
  }

  function enhanceCard(card) {
    if (!card || card.nodeType !== 1 || card.dataset.rnrNativeSwatchesComplete === 'true') return;

    var handle = getProductHandle(card);
    if (!handle) return;

    card.dataset.rnrNativeSwatchesComplete = 'true';
    loadProductSwatches(handle).then(function (data) {
      if (!document.documentElement.contains(card)) return;
      renderSwatches(card, data);
    });
  }

  function getCards(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches('.product-card-wrapper')) return [scope];
    return scope.querySelectorAll('.product-card-wrapper');
  }

  function observeCards(root) {
    var cards = getCards(root);
    Array.prototype.forEach.call(cards, function (card) {
      if (card.dataset.rnrNativeObserved === 'true') return;
      card.dataset.rnrNativeObserved = 'true';

      if (cardObserver) {
        cardObserver.observe(card);
      } else {
        enhanceCard(card);
      }
    });
  }

  function initCardObserver() {
    if (!('IntersectionObserver' in window) || cardObserver) return;
    cardObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        cardObserver.unobserve(entry.target);
        enhanceCard(entry.target);
      });
    }, { rootMargin: '600px 0px' });
  }

  function initMutationObserver() {
    if (observer || !document.body) return;
    observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
          if (node.nodeType === 1) observeCards(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    initCardObserver();
    observeCards(document);
    initMutationObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    observeCards(event.target || document);
  });
})();
